import React from "react";
import { Button } from "./ButtonStyled";
import svg1 from "../images/svg-1.svg";
import { ReactComponent as ImageOne } from "../images/svg-1.svg";
import { ReactComponent as ImageTwo } from "../images/svg-2.svg";
import { ReactComponent as ImageThree } from "../images/svg-3.svg";

import {
  BtnWrap,
  Column1,
  Column2,
  Heading,
  Img,
  ImgWrap,
  InfoContainer,
  InfoRow,
  InfoWrapper,
  Subtitle,
  TextWrapper,
  TopLine,
} from "./InfoSectionStyled";

const InfoSection = ({
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  headLine,
  darkText,
  description,
  buttonLabel,
  img,
  alt,
  primary,
  dark,
  dark2,
}) => {
  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headLine}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                <BtnWrap>
                  <Button
                    to="home"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exacts="true"
                    offset={-80}
                    primary={primary ? 1 : 0}
                    dark={dark ? 1 : 0}
                    dark2={dark2 ? 1 : 0}
                  >
                    {buttonLabel}{" "}
                  </Button>
                </BtnWrap>
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                {/*   <Img img={ImageOne} alt={alt} />
               <ImageOne width="100%"height="500px" />  */}

                {img === "img1" ? (
                  <ImageOne width="100%" height="500px" />
                ) : img === "img2" ? (
                  <ImageTwo width="100%" height="500px" />
                ) : (
                  <ImageThree width="100%" height="500px" />
                )}
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
